import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'

import BootstrapVue3 from 'bootstrap-vue-3'
import 'bootswatch/dist/brite/bootstrap.min.css'
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css'

import VueKonva from "vue-konva";

import "./assets/styles/main.css";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('./components/Home.vue')
    },
    {
      path: '/draw',
      name: 'Draw',
      component: () => import('./components/Draw.vue')
    },
    {
      path: '/visualize',
      name: 'Visualize',
      component: () => import('./components/VisualizeRuns.vue')
    },
    {
      path: '/runner-space',
      name: 'RunnerSpace',
      component: () => import('./components/RunnerSpace.vue')
    },
    {
      path: '/mycorridox',
      name: 'CorridoxList',
      component: () => import('./components/CorridoxList.vue')
    },
    {
      path: '/account',
      name: 'MyAccount',
      component: () => import('./components/MyAccount.vue')
    },
    {
      path: '/terms',
      name: 'TermsOfService',
      component: () => import('./components/TermsOfService.vue')
    },
    {
      path: '/verify-email',
      name: 'VerifyEmail',
      component: () => import('./components/VerifyEmail.vue')
    },
    {
      path: '/new-corridox',
      name: 'NewCorridox',
      component: () => import('./components/NewCorridox.vue')
    },
    {
      path: '/upload-map',
      name: 'UploadMap',
      component: () => import('./components/UploadMap.vue')
    },
    {
      path: '/upload-gpx/:corridoxId',
      name: 'UploadGPX',
      component: () => import('./components/UploadGPX.vue')
    },
  ]
})

const app = createApp(App)
app.use(router)
app.use(BootstrapVue3)
app.use(VueKonva)
app.mount('#app')
